import React, { FC } from "react";
import clsx from "clsx";

import { useTranslation } from "react-i18next";

import Select from "~/shared/ui/Fields/SelectZD";
import Button from "~/shared/ui/Fields/Button";

import s from "./SelectDealerForm.less";

interface IProps {
  reportSelect: [];
  control?;
  loading?;
  getReports?;
  menuCustom?;
  errors?;
  handleSubmit?;
  reprotFO?;
}

const ZDPlanReportForm: FC<IProps> = ({
  reportSelect,
  errors,
  menuCustom,
  control,
  loading,
  getReports,
  handleSubmit,
  reprotFO,
}) => {
  const { t } = useTranslation();

  return (
    <form onSubmit={handleSubmit(getReports)} className={s.select_dealer_wrap}>
      {!reprotFO && (
        <Select
          name={`dealers`}
          type="zd"
          control={control}
          label={t("zd.select_name")}
          menuCustom={menuCustom}
          error={errors["dealers"]?.value?.message}
          desc
          defaultValue={{
            value: null,
            label: t("zd.nothingSelected"),
          }}
          optionObjects={reportSelect}
          vertical
          customClassName={s.dealer_form_select}
        />
      )}

      <Button
        txtBtn={t("editorQ.save_report")}
        customClassName={clsx(s.btn_center, s.correct_margin)}
        isForm
        loading={loading}
      />
    </form>
  );
};
export default ZDPlanReportForm;
